/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "log2api",
            "endpoint": "https://qrngb4pcef.execute-api.ap-northeast-1.amazonaws.com/develop",
            "region": "ap-northeast-1"
        },
        {
            "name": "omikujiapi",
            "endpoint": "https://s92bq363zb.execute-api.ap-northeast-1.amazonaws.com/develop",
            "region": "ap-northeast-1"
        },
        {
            "name": "omikujilogs",
            "endpoint": "https://sy20p6onug.execute-api.ap-northeast-1.amazonaws.com/develop",
            "region": "ap-northeast-1"
        },
        {
            "name": "omikujilogsapi",
            "endpoint": "https://9b7ba17zfg.execute-api.ap-northeast-1.amazonaws.com/develop",
            "region": "ap-northeast-1"
        },
        {
            "name": "omikujimage",
            "endpoint": "https://qess8cwcd1.execute-api.ap-northeast-1.amazonaws.com/develop",
            "region": "ap-northeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://aqw3hcfcrjfz3fvqo4d54n62qm.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-sy5y3rkfmvdxvgswtrkivkdhci",
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "omikujilogs-develop",
            "region": "ap-northeast-1"
        }
    ]
};


export default awsmobile;
